// ────────────────────────────────────────────────────────────────────────────────────────────── I ──────────
//   :::::: S U B M I S S I O N S   A C T I O N   T Y P E S : :  :   :    :     :        :          :
// ────────────────────────────────────────────────────────────────────────────────────────────────────────
//

export const SAVE_QUIZ_SUBMISSIONS = 'SAVE_QUIZ_SUBMISSIONS';
export const SAVE_USER_SUBMISSIONS = 'SAVE_USER_SUBMISSIONS';
